import { render, staticRenderFns } from "./MessageLog.vue?vue&type=template&id=337981d9&"
import script from "./MessageLog.vue?vue&type=script&lang=js&"
export * from "./MessageLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports